import { render, staticRenderFns } from "./OfferBookingAddTalentModal.vue?vue&type=template&id=1648bb5e"
import script from "./OfferBookingAddTalentModal.vue?vue&type=script&lang=js"
export * from "./OfferBookingAddTalentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports